module.exports = __webpack_public_path__ + "static/media/Choux-de-bruxelles.dad26f05.svg";